/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Attributes_To_FillInputs */

const en_queue_attributes_to_fill = /** @type {(inputs: Queue_Attributes_To_FillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes to fill in`)
};

/**
* | output |
* | --- |
* | "Attributes to fill in" |
*
* @param {Queue_Attributes_To_FillInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_attributes_to_fill = /** @type {((inputs?: Queue_Attributes_To_FillInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Attributes_To_FillInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_attributes_to_fill(inputs)
});